import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import { withLocalize, LocalizeContextProps, Translate } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';
import { UploadFile, UploadProps } from "antd/lib/upload/interface";

import StudentStatementDTO from 'src/models/statement/StudentStatementDTO';
import { Checkbox, Button, message, Icon, Col, Row, Spin } from 'antd';
import StatementApiController from 'src/api/StatementApiController';
import EditStatementNotesModal, { StudentStatementModalReturn } from './EditStatementNotesModal';
import './StudentStatements.less';
import Routes from 'src/core/Routes';
import { Link } from 'react-router-dom';
import UpdateStudentStatementDTO from '../../models/statement/UpdateStudentStatementDTO';
import UserCompletionDTO from '../../models/statement/UserCompletionDTO';


interface StudentStatementsProps extends LocalizeContextProps {
}

interface StudentStatementsState {
    statements: StudentStatementDTO[];
    selectedStatement: StudentStatementDTO;
    isLoading: boolean;
    isInitialized: boolean;
}

class StudentStatements extends React.Component<StudentStatementsProps, StudentStatementsState> {
    constructor(props: StudentStatementsProps) {
        super(props);
        bindAllOfThis(this, StudentStatements.prototype);

        this.state = {
            statements: [],
            selectedStatement: null,
            isLoading: true,
            isInitialized: false,
        };
    }

    componentDidMount() {
        StatementApiController.getStudentIStatements().then(response => {
            if (response.ok) {
                return this.setState({
                    statements: response.data.items,
                    isLoading: false,
                    isInitialized: true,
                });
            }
            console.error("Error with getStudentIStatements()");
            this.setState({
                isLoading: false,
                isInitialized: true,
            });
        });
    }

    private closeModal() {
        this.setState({
            selectedStatement: null
        });
    }

    private openModal(statement: StudentStatementDTO) {
        this.setState({
            selectedStatement: statement,
        });
    }

    /**
     * Update DB with new notes/completed state for statement
     */
    private handleSubmit(values: StudentStatementModalReturn) {
        this.setState({isLoading: true});
        var updateStudentStatementDTO = {
            statementId: values.statementId,
            userId: values.userId,
            gradeId: values.gradeId,
            completed: values.userCompletion.isCompleted,
            notes: values.userCompletion.statementNotes,
            removedFileIds: values.removedFileIds
        } as UpdateStudentStatementDTO;

        const { fileList } = values;
        const formData = new FormData();
        var json = JSON.stringify(updateStudentStatementDTO);
        formData.append('jsonStringifiedObject', json);

        // Filter by status as it is null on a new UploadFile object
        fileList.filter(file => file != null && file.status == null).forEach(file => {
            if (file.originFileObj == null) {
                formData.append('Files[]', file as any);
            } else {
                formData.append('Files[]', file.originFileObj as any);
            }
        });

        // Update statement in DB
        StatementApiController.updateStudentStatement({ formData: formData }).then(result => {
            if (result.ok) {
                // Get statements from DB again to ensure have the updated info
                StatementApiController.getStudentIStatements().then(response => {
                    if (response.ok) {
                        this.setState({
                            statements: response.data.items,
                            selectedStatement: null,
                            isLoading: false,
                        });
                        message.success(this.props.translate("public.studentStatements.successMessage"));
                    } else {
                        console.error(response.statusText);
                        message.error(this.props.translate("public.studentStatements.errorMessage"));
                    }
                });
            }
            else if (result.status === 415) {
                console.error(result.statusText);
                message.error(this.props.translate("public.studentStatements.unsupportedMedia"));
            }
            else {
                console.error(result.statusText);
                message.error(this.props.translate("public.studentStatements.errorMessage"));
            }
        });
    }

    private handleCheckboxChange(statement: StudentStatementDTO, value: boolean) {
        let userCompletion = {
            ...statement.userCompletion,
            isCompleted: value,
        } as UserCompletionDTO;
        let studentStatementModalReturn: StudentStatementModalReturn = {
            ...statement,
            userCompletion: userCompletion,
            fileList: [], // since there are no files to update
            removedFileIds: []
        };

        this.handleSubmit(studentStatementModalReturn);
    }

    renderAllStatements() {
        return this.state.statements.map(statement => {
            let isChecked = statement.userCompletion != null && statement.userCompletion.isCompleted;
            return <div key={"statement" + statement.statementId}>
                <Row gutter={48} align={"top"} justify={"center"} type={"flex"}>
                    <Col span={5} offset={3}>
                        <p>
                            <Translate id="admin.studentStatements.columnHeader2" />
                            <Checkbox
                                className="checkbox"
                                defaultChecked={isChecked}
                                disabled={this.state.isLoading}
                                onChange={e => this.handleCheckboxChange(statement, e.target.checked)}>
                            </Checkbox>
                        </p>
                    </Col>
                    <Col span={8}>
                        <p>{statement.statementText}</p>
                    </Col>
                    <Col span={5}>
                        <p className="notes">
                            <Button
                                type="default"
                                className="ant-btn"
                                disabled={this.state.isLoading}
                                onClick={() => this.openModal(statement)}>
                                <Translate id="public.studentStatements.notesHeader" /> <Icon type="profile" />
                            </Button>
                        </p>
                    </Col>
                </Row>
            </div>;
        });
    }

    renderNoteModal() {
        if (this.state.selectedStatement == null) {
            return null;
        }

        return <EditStatementNotesModal
            visible={this.state.selectedStatement != null}
            statement={this.state.selectedStatement}
            onCancel={this.closeModal}
            onOk={this.handleSubmit} />;
    }

    render() {
        if (!this.state.isInitialized) {
            return <Spin />;
        }
        if (this.state.statements.length === 0) {
            return null;
        }

        return (
            <div className="student-statements">
                <h2><Translate id='admin.statements.tableHeader' /></h2>
                {this.renderAllStatements()}
                {this.renderNoteModal()}
            </div >
        );
    }
}

export default withLocalize(StudentStatements);



// WEBPACK FOOTER //
// ./src/components/student/StudentStatements.tsx